var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceivedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.336,
    height: 44,
    viewBox: "0 0 35.336 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "received_Icon",
    transform: "translate(-13.5 -4.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36318",
    "data-name": "Path 36318",
    d: "M44.48,20.387a1.127,1.127,0,0,0,1.114-1.114c0-3.243,2.855-5.663,2.855-5.663a1.108,1.108,0,0,0,.388-.823V9.98a1.127,1.127,0,0,0-1.114-1.114H41.768L39.3,5.285A1.1,1.1,0,0,0,38.38,4.8H23.908a1.244,1.244,0,0,0-.919.484L20.519,8.866H14.614A1.127,1.127,0,0,0,13.5,9.98v2.808a1.033,1.033,0,0,0,.388.823,8.239,8.239,0,0,1,2.855,5.663,1.127,1.127,0,0,0,1.114,1.114h2.178v1.645H14.614A1.127,1.127,0,0,0,13.5,23.146v2.808a1.033,1.033,0,0,0,.388.823,8.239,8.239,0,0,1,2.855,5.663,1.127,1.127,0,0,0,1.114,1.114h2.178V35.2l-5.421,0A1.127,1.127,0,0,0,13.5,36.314v2.808a1.033,1.033,0,0,0,.388.823,8.239,8.239,0,0,1,2.855,5.663,1.127,1.127,0,0,0,1.114,1.114l2.178,0v.968A1.127,1.127,0,0,0,21.149,48.8H41.188A1.127,1.127,0,0,0,42.3,47.687v-.968H44.48a1.127,1.127,0,0,0,1.114-1.114c0-3.243,2.855-5.663,2.855-5.663a1.108,1.108,0,0,0,.388-.823V36.312A1.127,1.127,0,0,0,47.723,35.2l-5.421,0V33.555H44.48a1.127,1.127,0,0,0,1.114-1.114c0-3.243,2.855-5.663,2.855-5.663a1.108,1.108,0,0,0,.388-.823V23.148a1.127,1.127,0,0,0-1.114-1.114l-5.421,0V20.387ZM46.658,12.3a10.38,10.38,0,0,0-3.2,5.905H42.3V11.094h4.357ZM24.488,7.027H37.849l1.307,1.887-15.974,0ZM18.874,18.209a10.551,10.551,0,0,0-3.2-5.905v-1.21h4.357v7.115Zm0,13.166a10.372,10.372,0,0,0-3.2-5.905V24.26h4.357v7.115Zm0,13.119a10.372,10.372,0,0,0-3.2-5.905v-1.21h4.357v7.115Zm21.249,2.082H22.213V11.094H40.074V46.576Zm6.535-9.2v1.21a10.38,10.38,0,0,0-3.2,5.905H42.3V37.379Zm0-13.168v1.21a10.38,10.38,0,0,0-3.2,5.905l-1.161,0V24.211Z",
    fill: "#ed1f24"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_723",
    "data-name": "Ellipse 723",
    cx: 3.235,
    cy: 3.235,
    r: 3.235,
    transform: "translate(28.042 26.424)",
    fill: "#adb7c0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_725",
    "data-name": "Ellipse 725",
    cx: 3.235,
    cy: 3.235,
    r: 3.235,
    transform: "translate(28.042 37.934)",
    fill: "#adb7c0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_724",
    "data-name": "Ellipse 724",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(25.042 11.914)",
    fill: "#ed1f24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedIcon);
export default __webpack_public_path__ + "static/media/Received_Icon.d59f20aa.svg";
export { ForwardRef as ReactComponent };